export default __webpack_public_path__ + "static/media/flower.9559e1da.svg";